<template>
  <div class="w-full flex items-center justify-center px-4 py-16">
    <div class="w-full max-w-md bg-gray-800 rounded-xl border border-gray-700 px-8 py-10 shadow-xl">
      <!-- Logo + title -->
      <div class="flex flex-col items-center mb-8">
        <img
          src="~/static/dropsIcon.png"
          class="w-16 h-16 object-contain mb-4"
          alt="Drops"
        >
        <h1 class="text-2xl font-bold tracking-widest text-gray-100 uppercase">
          Drops
        </h1>
        <p class="text-gray-500 text-sm mt-1">
          AR experiences, anywhere
        </p>
      </div>

      <!-- Error banner -->
      <div v-show="error" class="mb-4 rounded px-4 py-3 bg-red-900/50 border border-red-700 text-red-300 text-sm">
        The email or password you've entered is incorrect.
        <a href="/login/forgot" class="underline hover:text-red-200 ml-1">Forgot Password?</a>
      </div>

      <!-- Social logins (hidden for private beta) -->
      <template v-if="showSocialLogin">
        <button
          type="button"
          class="tw-btn w-full bg-green-600 hover:bg-green-700 text-white border-green-600 mb-2"
          @click="loginSpotify"
        >
          <font-awesome-icon :icon="['fab', 'spotify']" class="mr-2" />
          Login via Spotify
        </button>
        <button
          type="button"
          class="tw-btn w-full bg-gray-700 hover:bg-gray-600 text-white border-gray-600 mb-4"
          @click="loginSketchfab"
        >
          Login via Sketchfab
        </button>
        <div class="flex items-center gap-3 mb-4">
          <div class="flex-1 h-px bg-gray-700" />
          <span class="text-xs text-gray-500">or</span>
          <div class="flex-1 h-px bg-gray-700" />
        </div>
      </template>

      <!-- Form -->
      <form class="space-y-4" @submit.prevent="submitForm(userInfo, confirmPassword)">
        <div v-if="isRegister">
          <label class="tw-form-label" for="name">Full Name</label>
          <input
            id="name"
            v-model="userInfo.name"
            type="text"
            name="name"
            class="tw-form-input"
            required
          >
        </div>

        <div>
          <label class="tw-form-label" for="email">Email</label>
          <input
            id="email"
            v-model="userInfo.email"
            type="email"
            name="email"
            class="tw-form-input"
            autocomplete="email"
            required
          >
        </div>

        <div v-if="isRegister">
          <label class="tw-form-label" for="username">Username</label>
          <input
            id="username"
            v-model="userInfo.username"
            type="text"
            name="username"
            class="tw-form-input"
            required
          >
        </div>

        <div>
          <label class="tw-form-label" for="password">Password</label>
          <input
            id="password"
            v-model="userInfo.password"
            type="password"
            class="tw-form-input"
            autocomplete="current-password"
            required
          >
        </div>

        <div v-if="isRegister">
          <label class="tw-form-label" for="confirm-password">Confirm Password</label>
          <input
            id="confirm-password"
            v-model="confirmPassword"
            type="password"
            class="tw-form-input"
          >
        </div>

        <div v-if="isRegister" class="flex items-center gap-2">
          <input
            id="mailing-list"
            v-model="userInfo.mailingList"
            type="checkbox"
            class="w-4 h-4 rounded border-gray-500 bg-gray-700 text-blue-500"
          >
          <label for="mailing-list" class="text-sm text-gray-400">
            Sign up to receive the Drops newsletter
          </label>
        </div>

        <button
          type="submit"
          class="tw-btn w-full bg-blue-600 hover:bg-blue-500 text-white border-blue-600 font-semibold mt-2"
        >
          {{ buttonText }}
        </button>

        <p v-if="!isRegister" class="text-center mt-4">
          <NuxtLink to="/login/forgot" class="text-sm text-gray-500 hover:text-gray-300 underline">
            Forgot Password?
          </NuxtLink>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ['submitForm', 'buttonText', 'isRegister'],
  data () {
    return {
      showSocialLogin: false,
      error: false,
      loading: false,
      userInfo: {
        name: '',
        email: '',
        username: '',
        password: '',
        mailingList: false
      },
      confirmPassword: ''
    }
  },
  methods: {
    async loginSpotify () {
      try {
        const response = await this.$auth.loginWith('spotify')
        this.$auth.setUser(response.data.user)
      } catch (err) {
        // console.log(err)
      }
    },
    async loginSketchfab () {
      try {
        await this.$axios.get('auth/sketchfab/authorize')
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
